import { useEffect, useState, useRef } from "react";
import { NumericFormat } from "react-number-format";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { useReactToPrint } from "react-to-print";
import { reportCRUD } from "../../actions/report";
import { PrintHeader } from "../../layout/PrintHeader";

export const Report2 = () => {
  const tableRef = useRef(null);
  const dataRef = useRef(null);

  const [dataMale, setDataMale] = useState([]);
  const [dataFemale, setDataFemale] = useState([]);
  const [eCheck, setECheck] = useState(false);
  const [dCheck, setDCheck] = useState(false);
  const [disabled, setDisable] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (eCheck) {
      setDisable(false);
    } else if (dCheck) {
      setDisable(false);
    } else {
      setDisable(true);
    }
  }, [eCheck, dCheck]);

  useEffect(() => {
    setTimeout(() => {
      setLoading(true);
      reportCRUD
        .loadMemberEducationReport()
        .then((resp) => {
          setDataMale(resp.data.result_male);
          setDataFemale(resp.data.result_female);
        })
        .finally(() => {
          setLoading(false);
        });
    }, 500);
  }, []);

  const handleGeneratePdf = useReactToPrint({
    content: () => dataRef.current,
  });

  return (
    <>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0">Summary Report</h4>

                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        <a href="#">Report</a>
                      </li>
                      <li className="breadcrumb-item active">Form 2</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                  {loading ? (
                      <div className="d-flex justify-content-center">
                        <div
                          class="spinner-grow spinner-grow-sm text-primary me-1"
                          role="status"
                        >
                          <span class="sr-only">Loading...</span>
                        </div>
                        <div
                          class="spinner-grow spinner-grow-sm text-secondary me-1"
                          role="status"
                        >
                          <span class="sr-only">Loading...</span>
                        </div>
                        <div
                          class="spinner-grow spinner-grow-sm text-success me-1"
                          role="status"
                        >
                          <span class="sr-only">Loading...</span>
                        </div>
                        <div
                          class="spinner-grow spinner-grow-sm text-info me-1"
                          role="status"
                        >
                          <span class="sr-only">Loading...</span>
                        </div>
                        <div
                          class="spinner-grow spinner-grow-sm text-warning me-1"
                          role="status"
                        >
                          <span class="sr-only">Loading...</span>
                        </div>
                        <div
                          class="spinner-grow spinner-grow-sm text-danger me-1"
                          role="status"
                        >
                          <span class="sr-only">Loading...</span>
                        </div>
                        <div
                          class="spinner-grow spinner-grow-sm text-dark me-1"
                          role="status"
                        >
                          <span class="sr-only">Loading...</span>
                        </div>
                        <div
                          class="spinner-grow spinner-grow-sm text-light me-1"
                          role="status"
                        >
                          <span class="sr-only">Loading...</span>
                        </div>
                      </div>
                    ) : (
                    <div className="row">
                      <div className="col-md-9">
                        <div className="row d-flex justify-content-start">
                          <div className="col-auto">
                            <div className="form-check form-check-outline form-check-success mt-2 checkbox-lg">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="formCheck6"
                                onClick={() => setECheck(!eCheck)}
                              />
                              <label
                                className="form-check-label fs-5 mt-1"
                                for="formCheck6"
                              >
                                Education
                              </label>
                            </div>
                          </div>
                          <div className="col-auto">
                            <div className="form-check form-check-outline form-check-danger mt-2 checkbox-lg">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="formCheck6"
                                onClick={() => setDCheck(!dCheck)}
                              />
                              <label
                                className="form-check-label fs-5 mt-1"
                                for="formCheck6"
                              >
                                Disability
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="row d-flex justify-content-end">
                          <div className="col-auto">
                            <button
                              type="button"
                              className="btn btn-soft-danger"
                              disabled={disabled}
                              onClick={handleGeneratePdf}
                            >
                              <i className="bi bi-file-earmark-pdf bi-lg"></i>
                              &nbsp; PDF
                            </button>
                          </div>
                          <div className="col-auto">
                            <button
                              type="button"
                              className="btn btn-soft-success"
                              disabled={disabled}
                            >
                              <DownloadTableExcel
                                filename="report form2"
                                sheet="form2"
                                currentTableRef={tableRef.current}
                              >
                                <i className="bi bi-file-earmark-excel bi-lg"></i>
                                &nbsp; Excel
                              </DownloadTableExcel>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    )}
                  </div>
                  <div className="card-body" ref={dataRef}>
                    <PrintHeader subtitle="Education & Disability Report" />
                    <table
                      ref={tableRef}
                      id="scroll-vertical"
                      className="table table-bordered dt-responsive nowrap table-striped align-middle mdl-data-table"
                      style={{ width: "100%" }}
                    >
                      <thead>
                        <tr>
                          <th style={{ width: "80px" }}>SR No.</th>
                          <th className="d-flex justify-content-center">
                            Description
                          </th>
                          <th style={{ width: "180px" }}>Male</th>
                          <th style={{ width: "180px" }}>Female</th>
                          <th style={{ width: "180px" }}>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {eCheck && (
                          <>
                            <tr>
                              <td className="text-end">{eCheck && 1}</td>
                              <td colSpan={4}>Education Status</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>
                                Total children age 3 - 6 attending kindergarten
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={dataMale ? dataMale[0].total_3_6 : 0}
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={
                                    dataFemale ? dataFemale[0].total_3_6 : 0
                                  }
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={
                                    dataMale && dataFemale
                                      ? dataMale[0].total_3_6 +
                                        dataFemale[0].total_3_6
                                      : 0
                                  }
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>
                                Total children age 6 - 13 attending school
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={dataMale ? dataMale[1].total_6_13 : 0}
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={
                                    dataFemale ? dataFemale[1].total_6_13 : 0
                                  }
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={
                                    dataMale && dataFemale
                                      ? dataMale[1].total_6_13 +
                                        dataFemale[1].total_6_13
                                      : 0
                                  }
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>
                                Total children under 18 attending secondary
                                education
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={dataMale ? dataMale[2].total_under_18 : 0}
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={
                                    dataFemale ? dataFemale[2].total_under_18 : 0
                                  }
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={
                                    dataMale && dataFemale
                                      ? dataMale[2].total_under_18 +
                                        dataFemale[2].total_under_18
                                      : 0
                                  }
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>
                                Total children age 6 - 18 who have never
                                attended school
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={dataMale ? dataMale[3].total_under_18_no_education : 0}
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={
                                    dataFemale ? dataFemale[3].total_under_18_no_education : 0
                                  }
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={
                                    dataMale && dataFemale
                                      ? dataMale[3].total_under_18_no_education +
                                        dataFemale[3].total_under_18_no_education
                                      : 0
                                  }
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                            </tr>
                          </>
                        )}

                        {dCheck && (
                          <>
                            <tr>
                              <td className="text-end">{eCheck ? 2 : 1}</td>
                              <td colSpan={4}>Disability</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Total number of disability</td>
                              <td className="text-end">
                                <NumericFormat
                                  value={dataMale ? dataMale[4].total_disability : 0}
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={
                                    dataFemale ? dataFemale[4].total_disability : 0
                                  }
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={
                                    dataMale && dataFemale
                                      ? dataMale[4].total_disability +
                                        dataFemale[4].total_disability
                                      : 0
                                  }
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>
                                Total children under 18 with physical disability
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={dataMale ? dataMale[5].total_under_18_physical_disability : 0}
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={
                                    dataFemale ? dataFemale[5].total_under_18_physical_disability : 0
                                  }
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={
                                    dataMale && dataFemale
                                      ? dataMale[5].total_under_18_physical_disability +
                                        dataFemale[5].total_under_18_physical_disability
                                      : 0
                                  }
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>
                                Total children under 18 with mental disability
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={dataMale ? dataMale[6].total_under_18_mental_disability : 0}
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={
                                    dataFemale ? dataFemale[6].total_under_18_mental_disability : 0
                                  }
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={
                                    dataMale && dataFemale
                                      ? dataMale[6].total_under_18_mental_disability +
                                        dataFemale[6].total_under_18_mental_disability
                                      : 0
                                  }
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
